// Copyright 2022 Merit International Inc. All Rights Reserved

import { Platform } from "react-native";
import { Tooltip as TooltipDefault } from "./Tooltip";
import { Tooltip as TooltipWeb } from "./Tooltip.web";

export type { TooltipProps } from "./types";

export const Tooltip = Platform.select({ default: TooltipDefault, web: TooltipWeb });
